import { useFormik } from "formik";
import PhoneInputField from "../../../molecules/formControls/inputField/PhoneInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import Text from "../../../molecules/content/Text";
import { getCountryCode } from "../../../../helpers/utils";
import { useTranslation } from "react-i18next";
import phoneNumberValidationSchema from "./validations";

const PhoneNumberForm = ({ onSubmit, description, label }) => {
  let countryCode = getCountryCode();
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: { phone_number: "" },
    validationSchema: phoneNumberValidationSchema(t, countryCode),
    onSubmit: async (values) => {
      await onSubmit(values);
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col items-center gap-10"
    >
      <div className="w-full">
        <PhoneInputField
          id="phone_number"
          name="phone_number"
          required={true}
          onChange={formik.handleChange}
          countryCode={countryCode}
          onBlur={formik.handleBlur}
          value={formik.values.phone_number}
          formikTouched={formik.touched.phone_number}
          error={formik.errors.phone_number}
        />
      </div>
      <div className="flex flex-col items-center gap-4 w-full">
        {description && (
          <Text variant={"small"} className={"text-center"}>
            {description}
          </Text>
        )}

        <DefaultButton
          type="submit"
          label={label}
          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
        />
      </div>
    </form>
  );
};

export default PhoneNumberForm;
